import { Route, Routes, BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./QueryClient";

import Layout from "./components/layout/layout";
import Home from "./pages/home/home";
import WorkerRegister from "./pages/Register/workerregister";
import EmployerRegister from "./pages/Register/employerregister";
import Registerchoose from "./pages/Register/registerchoose";
import WorkerProfile from "./pages/profileworker/workerprofile";
import Createcv from "./pages/createcv/create_cv";
import CVTemplate from "./pages/createcv/finalCV";
import EmployerProfile from "./pages/Employerprofile/eployerprofile";
import Workererchoose from "./pages/Register/workerchoose";
import Employerchoose from "./pages/Register/employerchoose";
import Settings from "./pages/settings/settings";
import PersonalPage from "./pages/personalpage/personalpage";
import EmployerSettings from "./pages/settings/employersettings";
import BecomeaCandidate from "./pages/Becomecandidate/becomecandidate";
import AddVacancy from "./pages/addVacancie/addvacancie";
import ViewVacancie from "./pages/viewvacancie/viewvacancie";
import EditCompanyPage from "./pages/Companypage/editcompanypage";
import ViewCompanyPage from "./pages/Companypage/viewcompanypage";
import SearchResults from "./pages/searchresults/searchresults";
import NewsView from "./pages/myNews/newsview";
import ViewConmpanyVacancies from "./pages/Companypage/viewcompanyvacancies";
import MyNews from "./pages/myNews/mynews";
import AddNews from "./pages/addnews/addnews";
import GlobalNews from "./pages/globalnews/globalnews";
import Last_Posted_Vacancies from "./pages/postedVacanciesPage/postedVacancies";
import Companies from "./pages/companies/Companies";
import All_Highest_Sallary_Jobs from "./pages/allHighestsalaryJobs/allHighestSallaryJobs";
import MyLikedVacancies from "./pages/mylikedvacancies/mylikedVacancies";
import AdminPage from "./pages/AdminPage/adminpage";
import TopCandidates from "./pages/topcanditatespage/topCandidates";
import ViewCandidatePage from "./pages/viewCandidatePage/vewCandidatePage";
import NotificationPage from "./pages/notificationPage/notificationPage";
import ResponsePage from "./pages/responsesPage/responses";
import LikedCandidatesStyled from "./pages/likedCandidates/likedcandidates";
import AboutUs from "./pages/AboutUsPage/aboutUs";
import PrivacyPolicy from "./pages/privzacyPage/privacyPage";
import PricingPage from "./pages/Plans/Plans";
import EditNews from "./pages/myNews/EditNews";
import EditVacancy from "./pages/Companypage/EditVacancy";
export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="workerregister" element={<WorkerRegister />} />
            <Route path="employerregister" element={<EmployerRegister />} />
            <Route path="registerchoose" element={<Registerchoose />} />
            <Route path="WorkerChoose" element={<Workererchoose />} />
            <Route path="EmployerChoose" element={<Employerchoose />} />
            <Route path="workerprofile" element={<WorkerProfile />} />
            <Route path="Settings" element={<Settings />} />
            <Route path="myPersonalPage/:id?" element={<PersonalPage />} />
            <Route path="/create_cv" element={<Createcv />} />
            <Route path="/create_cv/:id" element={<Createcv />} />{" "}
            <Route path="cv/:cvId" element={<CVTemplate />} />
            <Route path="EmployerProfile" element={<EmployerProfile />} />
            <Route path="BecomeaCandidate" element={<BecomeaCandidate />} />
            <Route path="EditCompanyPage" element={<EditCompanyPage />} />
            <Route path="search" element={<SearchResults />} />
            <Route path="MyNews/:id" element={<MyNews />} />
            <Route path="AddNews/:id" element={<AddNews />} />
            <Route path="News/:id" element={<NewsView />} />
            <Route path="Global_News" element={<GlobalNews />} />
            <Route path="Top_Candidates" element={<TopCandidates />} />
            <Route path="Notifications" element={<NotificationPage />} />
            <Route path="Responses" element={<ResponsePage />} />
            <Route path="LikedCandidates" element={<LikedCandidatesStyled />} />
            <Route path="AboutUs" element={<AboutUs />} />
            <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route path="PricingPage" element={<PricingPage />} />
            <Route
              path="ViewCandidatePage/:id"
              element={<ViewCandidatePage />}
            />
            <Route
              path="Last_Posted_Vacancies"
              element={<Last_Posted_Vacancies />}
            />
            <Route path="Companies" element={<Companies />} />
            <Route
              path="All_Highest_Sallary_Jobs"
              element={<All_Highest_Sallary_Jobs />}
            />
            <Route path="MyLikedVacancies/:id" element={<MyLikedVacancies />} />
            <Route
              path="ViewCompanyVacancies/:id"
              element={<ViewConmpanyVacancies />}
            />
            <Route path="ViewCompanyPage/:id" element={<ViewCompanyPage />} />
            <Route path="AddVacancy" element={<AddVacancy />} />
            <Route path="EmployerSettings" element={<EmployerSettings />} />
            <Route path="vacancy/:id" element={<ViewVacancie />} />
            <Route path="Admin_Page" element={<AdminPage />} />
            <Route path="/EditNews/:id" element={<EditNews />} />
            <Route path="/EditVacancy/:id" element={<EditVacancy />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
